import { apiClient } from "./ApiClient";

export const retrieveAllTravelCalendarEntriesApi = () =>
  apiClient.get(`/travel-calendar-view/entries`);

export const retrieveTravelCalendarEntriesByUserIdApi = (userId) =>
  apiClient.get(`/travel-calendar-view/entries/user/${userId}`);

export const retrieveTravelCalendarEntriesByUserIdAndDateRangeApi = (userId, startDate, endDate) =>
  apiClient.get(`/travel-calendar-view/entries/user/${userId}/range`, {
    params: { startDate, endDate },
  });

export const retrieveTravelCalendarEntriesByDateRangeApi = (startDate, endDate) =>
  apiClient.get(`/travel-calendar-view/entries/range`, {
    params: { startDate, endDate },
  });

export const createTravelCalendarEntryApi = (entry) =>
  apiClient.post(`/travel-calendar-view/add`, entry);

export const createMultipleTravelCalendarEntriesApi = (entries) =>
  apiClient.post(`/travel-calendar-view/add-multiple`, entries);

export const updateTravelCalendarEntryApi = (id, entry) =>
  apiClient.put(`/travel-calendar-view/edit/${id}`, entry);

export const deleteMultipleTravelCalendarEntriesApi = (idList) =>
  apiClient.put(`/travel-calendar-view/delete-list`, idList);

export const retrieveTravelCalendarEntryByIdApi = (id) =>
  apiClient.get(`/travel-calendar-view/get/${id}`);

export const retrieveFilteredTravelCalendarEntriesApi = (filterDto) =>
  apiClient.post(`/travel-calendar-view/filter`, filterDto);

export const retrieveSharedSpecialOccasionsApi = (startDate, endDate) =>
  apiClient.get(`/travel-calendar-view/shared-occasions`, {
    params: { startDate, endDate },
  });

export const updateApprovalStatusApi = (id, status, note) =>
  apiClient.put(`/travel-calendar-view/approve/${id}`, null, {
    params: { status, note: note || undefined },
  });

export const bulkUpdateApprovalStatusApi = (idList, status, note) =>
  apiClient.put(`/travel-calendar-view/approve-bulk`, idList, {
    params: { status, note: note || undefined },
  });

export const retrievePendingApprovalEntriesApi = () =>
  apiClient.get(`/travel-calendar-view/entries/pending-approval`);

// ─── Calendar Delegate Access ───

/** Returns all users granted edit access to the current user's calendar. */
export const getCalendarDelegateGrantsApi = () =>
  apiClient.get(`/travel-calendar-view/delegates/my-grants`);

/** Returns all calendars (owners) the current user has been granted delegate access to. */
export const getCalendarDelegateAccessApi = () =>
  apiClient.get(`/travel-calendar-view/delegates/my-access`);

/** Grants a user edit access to the current user's calendar. */
export const grantCalendarDelegateAccessApi = (delegateUserId) =>
  apiClient.post(`/travel-calendar-view/delegates/grant/${delegateUserId}`);

/** Revokes a user's edit access to the current user's calendar. */
export const revokeCalendarDelegateAccessApi = (delegateUserId) =>
  apiClient.delete(`/travel-calendar-view/delegates/revoke/${delegateUserId}`);
